/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_CookiesInputs */

const en_privacy_section_2_item_cookies = /** @type {(inputs: Privacy_Section_2_Item_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie consent preferences`)
};

const lv_privacy_section_2_item_cookies = /** @type {(inputs: Privacy_Section_2_Item_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sīkdatņu piekrišanas iestatījumi`)
};

/**
* | output |
* | --- |
* | "Cookie consent preferences" |
*
* @param {Privacy_Section_2_Item_CookiesInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_cookies = /** @type {((inputs?: Privacy_Section_2_Item_CookiesInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_CookiesInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_cookies(inputs)
	return en_privacy_section_2_item_cookies(inputs)
});